const getResolutionData = (resolution) => {
    let width = ''
    let height = ''

    if (resolution) {
        const xSign = resolution.indexOf('x')
        if (xSign > -1) {
            width = resolution.slice(0, xSign)
            height = resolution.slice(xSign + 1, resolution.length)
        }
    }

    return { width, height }
}

export default () => {
    const url = new URL(window.location.href)
    const searchParams = new URLSearchParams(url.search)

    // hide 'iid' string in char codes in minify code
    const iid = searchParams.get(String.fromCharCode(105, 105, 100))
    // hide 'support' string in char codes in minify code
    const support = searchParams.get(String.fromCharCode(115, 117, 112, 112, 111, 114, 116))

    // ToDo: remove it after support will come at game
    if (support === null) return 2

    if (!support || !support.length || isNaN(Number(support)) || isNaN(Number(iid))) return ''
    // SALT
    // query_support = (10 - target_support) * iid =>
    // target_support = (10 * iid - query_support) / iid
    // target_support === 1 -> open meya now
    // target_support === 2 -> open meya after hard way
    // target_support === 3 or other -> never open meya
    return (10 * Number(iid) - Number(support)) / Number(iid)
}

export const getUserParams = () => {
    const url = new URL(window.location.href)
    const searchParams = new URLSearchParams(url.search)

    const appId = process.env.VUE_APP_GAME_MEYA_APP_ID

    const uid = searchParams.get('uid')
    const iid = searchParams.get('iid')
    const ram = searchParams.get('ram')
    const { width, height } = getResolutionData(searchParams.get('resolution'))
    const lang = searchParams.get('lang')
    const platform = searchParams.get('platform')
    const game = searchParams.get('game')

    return {
        appId, uid, iid, ram, width, height, lang, platform, game
    }
}

export let isFirstEnter = true

export function removeFirstEnter() {
    isFirstEnter = false
}

export function isMeyaSplit() {
    const getMeyaSplit = () => {
        const { uid } = getUserParams()

        const chance = process.env.VUE_APP_FEEDBACK_SPLIT

        if (uid) {
            const lastSings = uid.slice(-2)

            return parseInt(lastSings) < chance
        } else {
            return false
        }
    }

    const isIdAccepted = () => {
        const { uid } = getUserParams()

        const acceptIds = [
            '102000000000000067301536',
            '102000000000000025941403',
            '102000000000000005223505',
            '102000000000000066986643',
            '102000000000000010402775',
            '102000000000000039651903',
            '101000000000000058939824',
            '101000000000000060995447',
            '101000000000000073343715',
            '102000000000000105052656',
            '102000000000000094210629',
            '101000000000000001969497',
            '101000000000000095398649',
            '102000000000000103617617',
            '101000000000000056447226',
            '102000000000000103406126',
            '102000000000000062038370',
            '102000000000000059850690',
            '102000000000000086260670',
            '102000000000000086933736',
            '102000000000000088039374',
            '101000000000000094762859',
            '102000000000000096522659',
            '102000000000000102326192',
            '101000000000000105413919',
            '102000000000000012074977',
            '102000000000000059867686',
            '102000000000000002223726',
            '102000000000000050425194',
            '102000000000000064882179',
            '102000000000000088380245',
            '102000000000000089649370',
            '101000000000000090189918',
            '102000000000000091847594',
            '102000000000000092711854',
            '102000000000000098155569',
            '102000000000000103361654',
            '101000000000000104770987',
            '102000000000000003161519',
            '102000000000000002646836',
            '102000000000000003127536',
            '102000000000000111463996',
            '102000000000000025941403',
            '101000000000000050826254',
            '102000000000000004146885',
            '102000000000000091291111',
            '102000000000000051971672',
            '102000000000000047419759',
            '102000000000000014258816',
            '102000000000000054729076',
            '102000000000000094573109',
        ]

        return acceptIds.includes(uid)
    }

    return isIdAccepted() || getMeyaSplit()
}

export function isMeyaHWMGame() {
    const { game, platform } = getUserParams()

    const hwmGameCodes = {
        hwm: {
            key: 'hwm',
        },
        _ch: {
            key: '_ch', platform: ['_android', '_ios', '_huawei']
        }
    }

    if (process.env.NODE_ENV === 'development') return true
    if (game === hwmGameCodes._ch.key) return hwmGameCodes._ch.platform.includes(platform)
    return game === hwmGameCodes.hwm.key
}
